import { useMemo } from "react";

import { FastMarketInfoData } from "..";

/**
 * DISABLED: This hook previously fetched market info from a Subgraph for faster initial render.
 * Now disabled in favor of on-chain multicall (no Subgraph dependency).
 * The UI will show a loading state until multicall completes.
 */
export function useFastMarketsInfoRequest(chainId: number) {
  return useMemo(
    () => ({
      fastMarketInfoData: undefined as FastMarketInfoData | undefined,
      error: undefined,
      isLoading: false,
    }),
    []
  );
}
